import { ROUTE_SEO_REGION } from '..'
import AddressNotFoundError from '../../domain/error/AddressNotFoundError'
import PageNotFoundError from '../../domain/error/PageNotFoundError'
import PermanentRedirectError from '../../domain/error/PermanentRedirectError'
import { bboxArrayToBboxArrays } from '../../domain/map/conversion'
import { generateFullRoute } from '../../domain/router/routeUtils'
import { renderPage } from '../../domain/seo/region.page'
import { extractCodeLabel } from '../../domain/utils/location'
import { searchArea } from '../../store/address/address.actions'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { mapUpdated } from '../../store/map/mapSlice'
import { geocodeForwardCtx, searchServiceCtx } from '../../store/search/search.service.constants'
import { setSearchTerms } from '../../store/search/searchSlice'
import { searchRegionCities } from '../../store/seo/seo-address.actions'
import { searchRegionDescription } from '../../store/seo/seo-zone.actions'
import { slugify } from '../../utils/string'
import { technicalErrorCatcher } from '../routeErrors.utils'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ params, store: { dispatch, getState }, avoidRefetchingPageData }) => {
  if (avoidRefetchingPageData) {
    return searchRegionDescription()(dispatch, getState)
  }
  const { location } = params
  const { code, label } = extractCodeLabel(location)
  if (!code || !label) throw new PageNotFoundError()

  return searchArea(location, geocodeForwardCtx.filter.state)(dispatch, getState)
    .then(() => {
      const firstAddress = selectFirstAddress(getState())

      if (firstAddress.geocode_level !== searchServiceCtx.geocodeLevel.admin1 || !firstAddress.regionCode) {
        throw new AddressNotFoundError()
      }

      if (firstAddress.regionCode !== code || slugify(firstAddress.regionLabel) !== label) {
        throw new PermanentRedirectError(
          generateFullRoute(ROUTE_SEO_REGION, {
            location: `${firstAddress.regionCode}-${slugify(firstAddress.regionLabel)}`
          })
        )
      }

      return Promise.all([
        dispatch(setSearchTerms(location)),
        __SERVER__ && searchRegionCities()(dispatch, getState),
        searchRegionDescription()(dispatch, getState),
        dispatch(mapUpdated({ bbox: bboxArrayToBboxArrays(firstAddress.bbox) }))
      ])
    })
    .catch(technicalErrorCatcher)
}

export default handleRouteLoading({ onRouteEnter, renderPage })
